module.exports = __webpack_public_path__ + "img/svg/background-navbar-header.d03f6e49a9f08b192080a7a2f71295a2.svg";